module.exports = __webpack_public_path__ + "img/topicLeisure.d6c9cc78.png";